var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFinish = function SvgFinish(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147_678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.001 40.0015C31.0467 40.0015 40.001 31.0472 40.001 20.0015C40.001 8.95577 31.0467 0.00146484 20.001 0.00146484C8.95528 0.00146484 0.000976562 8.95577 0.000976562 20.0015C0.000976562 31.0472 8.95528 40.0015 20.001 40.0015Z",
    fill: "url(#paint0_radial_147_678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "url(#paint1_linear_147_678)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "url(#paint2_radial_147_678)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9375 10.375H13.125V9.6875C13.125 9.30783 12.8175 9 12.4375 9C12.0575 9 11.75 9.30783 11.75 9.6875V30.3125C11.75 30.6922 12.0575 31 12.4375 31C12.8175 31 13.125 30.6922 13.125 30.3125V22.75H28.9375C29.3175 22.75 29.625 22.4422 29.625 22.0625V11.0625C29.625 10.6828 29.3175 10.375 28.9375 10.375ZM28.25 15.875H24.125V11.75H28.25V15.875ZM22.75 17.25V21.375H18.625V17.25H22.75ZM17.25 11.75V15.875H13.125V11.75H17.25Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_147_678)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49996 30C16.4787 30 27 19.4787 27 6.50003C27 4.6177 26.7786 2.78706 26.3606 1.03271C34.288 3.69003 40 11.178 40 20C40 31.0457 31.0457 40 20 40C12.5912 40 6.12327 35.9715 2.66724 29.9856C2.94362 29.9952 3.22122 30 3.49996 30Z",
    fill: "url(#paint3_linear_147_678)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_147_678",
    x: 1.3339,
    y: -0.300619,
    width: 39.9994,
    height: 41.634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_147_678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_147_678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_147_678",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9271 9.93628e-05) rotate(135) scale(34.9872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_147_678",
    x1: 18.3343,
    y1: -3.33334,
    x2: 0.000973962,
    y2: 23.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_147_678",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 9.5) rotate(143.291) scale(47.3994 39.1256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_147_678",
    x1: 21.3387,
    y1: 40,
    x2: 26.3302,
    y2: 11.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFinish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/finish.d5c47446.svg";
export { ForwardRef as ReactComponent };